export default __webpack_public_path__ + "static/media/info-img1.8fa59854.png";